import './JiraSummary.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getInitiativeJiraIssuesSelector } from '../../@arch/selectors';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { JiraIcon } from '@ui/icons';
import { JiraIssue } from './JiraIssue';
import { PostJiraIssueSyncNotifications } from '../../notifications';
import { SonarText } from '@ui/text';
import React, { useCallback } from 'react';
import { useAction, useInterval, useOnMount, useSonarSelector } from '@hooks';
export const JiraSummary = ({ initiativeId }) => {
    const getInitiativesJiraIssues = useAction(integrationsActions.requestGetInitiativeJiraIssues);
    const getJiraSummary = useAction(integrationsActions.requestGetJiraSummary);
    const refreshInitiativeJiraIssues = useCallback(() => {
        getInitiativesJiraIssues({
            initiativeId
        });
    }, [getInitiativesJiraIssues, initiativeId]);
    useOnMount(() => {
        refreshInitiativeJiraIssues();
        getJiraSummary();
    });
    useInterval(refreshInitiativeJiraIssues, 10000);
    const jiraIssueData = useSonarSelector(getInitiativeJiraIssuesSelector.data);
    const jiraIssues = jiraIssueData === null || jiraIssueData === void 0 ? void 0 : jiraIssueData.map((jiraIssue) => {
        const { issueName, issueKey, issueStatusId, isSynced, projectKey } = jiraIssue;
        return (React.createElement(JiraIssue, { initiativeId: initiativeId, issueKey: issueKey, issueName: issueName, isSynced: isSynced, key: issueKey, projectKey: projectKey, statusId: issueStatusId, summary: true }));
    });
    if (!(jiraIssueData === null || jiraIssueData === void 0 ? void 0 : jiraIssueData.length)) {
        return null;
    }
    return (React.createElement("div", { className: 'jira-issues-summary' },
        React.createElement(PostJiraIssueSyncNotifications, null),
        React.createElement("div", { className: 'summary-label' },
            React.createElement(JiraIcon, { className: 'jira-icon' }),
            React.createElement(SonarText, { className: 'summary-title', size: 16, strong: true }, COPY_SPECIFIC.JIRA_ISSUES)),
        jiraIssues));
};
